const CurrencyUtils = {
  AFN: {
    monetary_units: 2,
    name: 'Afghani',
  },
  EUR: {
    monetary_units: 2,
    name: 'Euro',
  },
  ALL: {
    monetary_units: 2,
    name: 'Lek',
  },
  DZD: {
    monetary_units: 2,
    name: 'Algerian Dinar',
  },
  USD: {
    monetary_units: 2,
    name: 'US Dollar',
  },
  AOA: {
    monetary_units: 2,
    name: 'Kwanza',
  },
  XCD: {
    monetary_units: 2,
    name: 'East Caribbean Dollar',
  },
  ARS: {
    monetary_units: 2,
    name: 'Argentine Peso',
  },
  AMD: {
    monetary_units: 2,
    name: 'Armenian Dram',
  },
  AWG: {
    monetary_units: 2,
    name: 'Aruban Florin',
  },
  AUD: {
    monetary_units: 2,
    name: 'Australian Dollar',
  },
  AZN: {
    monetary_units: 2,
    name: 'Azerbaijan Manat',
  },
  BSD: {
    monetary_units: 2,
    name: 'Bahamian Dollar',
  },
  BHD: {
    monetary_units: 3,
    name: 'Bahraini Dinar',
  },
  BDT: {
    monetary_units: 2,
    name: 'Taka',
  },
  BBD: {
    monetary_units: 2,
    name: 'Barbados Dollar',
  },
  BYN: {
    monetary_units: 2,
    name: 'Belarusian Ruble',
  },
  BZD: {
    monetary_units: 2,
    name: 'Belize Dollar',
  },
  XOF: {
    monetary_units: 0,
    name: 'CFA Franc BCEAO',
  },
  BMD: {
    monetary_units: 2,
    name: 'Bermudian Dollar',
  },
  INR: {
    monetary_units: 2,
    name: 'Indian Rupee',
  },
  BTN: {
    monetary_units: 2,
    name: 'Ngultrum',
  },
  BOB: {
    monetary_units: 2,
    name: 'Boliviano',
  },
  BOV: {
    monetary_units: 2,
    name: 'Mvdol',
  },
  BAM: {
    monetary_units: 2,
    name: 'Convertible Mark',
  },
  BWP: {
    monetary_units: 2,
    name: 'Pula',
  },
  NOK: {
    monetary_units: 2,
    name: 'Norwegian Krone',
  },
  BRL: {
    monetary_units: 2,
    name: 'Brazilian Real',
  },
  BND: {
    monetary_units: 2,
    name: 'Brunei Dollar',
  },
  BGN: {
    monetary_units: 2,
    name: 'Bulgarian Lev',
  },
  BIF: {
    monetary_units: 0,
    name: 'Burundi Franc',
  },
  CVE: {
    monetary_units: 2,
    name: 'Cabo Verde Escudo',
  },
  KHR: {
    monetary_units: 2,
    name: 'Riel',
  },
  XAF: {
    monetary_units: 0,
    name: 'CFA Franc BEAC',
  },
  CAD: {
    monetary_units: 2,
    name: 'Canadian Dollar',
  },
  KYD: {
    monetary_units: 2,
    name: 'Cayman Islands Dollar',
  },
  CLP: {
    monetary_units: 0,
    name: 'Chilean Peso',
  },
  CLF: {
    monetary_units: 4,
    name: 'Unidad de Fomento',
  },
  CNY: {
    monetary_units: 2,
    name: 'Yuan Renminbi',
  },
  COP: {
    monetary_units: 2,
    name: 'Colombian Peso',
  },
  COU: {
    monetary_units: 2,
    name: 'Unidad de Valor Real',
  },
  KMF: {
    monetary_units: 0,
    name: 'Comorian Franc ',
  },
  CDF: {
    monetary_units: 2,
    name: 'Congolese Franc',
  },
  NZD: {
    monetary_units: 2,
    name: 'New Zealand Dollar',
  },
  CRC: {
    monetary_units: 2,
    name: 'Costa Rican Colon',
  },
  HRK: {
    monetary_units: 2,
    name: 'Kuna',
  },
  CUP: {
    monetary_units: 2,
    name: 'Cuban Peso',
  },
  CUC: {
    monetary_units: 2,
    name: 'Peso Convertible',
  },
  ANG: {
    monetary_units: 2,
    name: 'Netherlands Antillean Guilder',
  },
  CZK: {
    monetary_units: 2,
    name: 'Czech Koruna',
  },
  DKK: {
    monetary_units: 2,
    name: 'Danish Krone',
  },
  DJF: {
    monetary_units: 0,
    name: 'Djibouti Franc',
  },
  DOP: {
    monetary_units: 2,
    name: 'Dominican Peso',
  },
  EGP: {
    monetary_units: 2,
    name: 'Egyptian Pound',
  },
  SVC: {
    monetary_units: 2,
    name: 'El Salvador Colon',
  },
  ERN: {
    monetary_units: 2,
    name: 'Nakfa',
  },
  ETB: {
    monetary_units: 2,
    name: 'Ethiopian Birr',
  },
  FKP: {
    monetary_units: 2,
    name: 'Falkland Islands Pound',
  },
  FJD: {
    monetary_units: 2,
    name: 'Fiji Dollar',
  },
  XPF: {
    monetary_units: 0,
    name: 'CFP Franc',
  },
  GMD: {
    monetary_units: 2,
    name: 'Dalasi',
  },
  GEL: {
    monetary_units: 2,
    name: 'Lari',
  },
  GHS: {
    monetary_units: 2,
    name: 'Ghana Cedi',
  },
  GIP: {
    monetary_units: 2,
    name: 'Gibraltar Pound',
  },
  GTQ: {
    monetary_units: 2,
    name: 'Quetzal',
  },
  GBP: {
    monetary_units: 2,
    name: 'Pound Sterling',
  },
  GNF: {
    monetary_units: 0,
    name: 'Guinean Franc',
  },
  GYD: {
    monetary_units: 2,
    name: 'Guyana Dollar',
  },
  HTG: {
    monetary_units: 2,
    name: 'Gourde',
  },
  HNL: {
    monetary_units: 2,
    name: 'Lempira',
  },
  HKD: {
    monetary_units: 2,
    name: 'Hong Kong Dollar',
  },
  HUF: {
    monetary_units: 2,
    name: 'Forint',
  },
  ISK: {
    monetary_units: 0,
    name: 'Iceland Krona',
  },
  IDR: {
    monetary_units: 2,
    name: 'Rupiah',
  },
  IRR: {
    monetary_units: 2,
    name: 'Iranian Rial',
  },
  IQD: {
    monetary_units: 3,
    name: 'Iraqi Dinar',
  },
  ILS: {
    monetary_units: 2,
    name: 'New Israeli Sheqel',
  },
  JMD: {
    monetary_units: 2,
    name: 'Jamaican Dollar',
  },
  JPY: {
    monetary_units: 0,
    name: 'Yen',
  },
  JOD: {
    monetary_units: 3,
    name: 'Jordanian Dinar',
  },
  KZT: {
    monetary_units: 2,
    name: 'Tenge',
  },
  KES: {
    monetary_units: 2,
    name: 'Kenyan Shilling',
  },
  KPW: {
    monetary_units: 2,
    name: 'North Korean Won',
  },
  KRW: {
    monetary_units: 0,
    name: 'Won',
  },
  KWD: {
    monetary_units: 3,
    name: 'Kuwaiti Dinar',
  },
  KGS: {
    monetary_units: 2,
    name: 'Som',
  },
  LAK: {
    monetary_units: 2,
    name: 'Lao Kip',
  },
  LBP: {
    monetary_units: 2,
    name: 'Lebanese Pound',
  },
  LSL: {
    monetary_units: 2,
    name: 'Loti',
  },
  ZAR: {
    monetary_units: 2,
    name: 'Rand',
  },
  LRD: {
    monetary_units: 2,
    name: 'Liberian Dollar',
  },
  LYD: {
    monetary_units: 3,
    name: 'Libyan Dinar',
  },
  CHF: {
    monetary_units: 2,
    name: 'Swiss Franc',
  },
  MOP: {
    monetary_units: 2,
    name: 'Pataca',
  },
  MKD: {
    monetary_units: 2,
    name: 'Denar',
  },
  MGA: {
    monetary_units: 2,
    name: 'Malagasy Ariary',
  },
  MWK: {
    monetary_units: 2,
    name: 'Malawi Kwacha',
  },
  MYR: {
    monetary_units: 2,
    name: 'Malaysian Ringgit',
  },
  MVR: {
    monetary_units: 2,
    name: 'Rufiyaa',
  },
  MRU: {
    monetary_units: 2,
    name: 'Ouguiya',
  },
  MUR: {
    monetary_units: 2,
    name: 'Mauritius Rupee',
  },
  MXN: {
    monetary_units: 2,
    name: 'Mexican Peso',
  },
  MXV: {
    monetary_units: 2,
    name: 'Mexican Unidad de Inversion (UDI)',
  },
  MDL: {
    monetary_units: 2,
    name: 'Moldovan Leu',
  },
  MNT: {
    monetary_units: 2,
    name: 'Tugrik',
  },
  MAD: {
    monetary_units: 2,
    name: 'Moroccan Dirham',
  },
  MZN: {
    monetary_units: 2,
    name: 'Mozambique Metical',
  },
  MMK: {
    monetary_units: 2,
    name: 'Kyat',
  },
  NAD: {
    monetary_units: 2,
    name: 'Namibia Dollar',
  },
  NPR: {
    monetary_units: 2,
    name: 'Nepalese Rupee',
  },
  NIO: {
    monetary_units: 2,
    name: 'Cordoba Oro',
  },
  NGN: {
    monetary_units: 2,
    name: 'Naira',
  },
  OMR: {
    monetary_units: 3,
    name: 'Rial Omani',
  },
  PKR: {
    monetary_units: 2,
    name: 'Pakistan Rupee',
  },
  PAB: {
    monetary_units: 2,
    name: 'Balboa',
  },
  PGK: {
    monetary_units: 2,
    name: 'Kina',
  },
  PYG: {
    monetary_units: 0,
    name: 'Guarani',
  },
  PEN: {
    monetary_units: 2,
    name: 'Sol',
  },
  PHP: {
    monetary_units: 2,
    name: 'Philippine Piso',
  },
  PLN: {
    monetary_units: 2,
    name: 'Zloty',
  },
  QAR: {
    monetary_units: 2,
    name: 'Qatari Rial',
  },
  RON: {
    monetary_units: 2,
    name: 'Romanian Leu',
  },
  RUB: {
    monetary_units: 2,
    name: 'Russian Ruble',
  },
  RWF: {
    monetary_units: 0,
    name: 'Rwanda Franc',
  },
  SHP: {
    monetary_units: 2,
    name: 'Saint Helena Pound',
  },
  WST: {
    monetary_units: 2,
    name: 'Tala',
  },
  STN: {
    monetary_units: 2,
    name: 'Dobra',
  },
  SAR: {
    monetary_units: 2,
    name: 'Saudi Riyal',
  },
  RSD: {
    monetary_units: 2,
    name: 'Serbian Dinar',
  },
  SCR: {
    monetary_units: 2,
    name: 'Seychelles Rupee',
  },
  SLL: {
    monetary_units: 2,
    name: 'Leone',
  },
  SGD: {
    monetary_units: 2,
    name: 'Singapore Dollar',
  },
  SBD: {
    monetary_units: 2,
    name: 'Solomon Islands Dollar',
  },
  SOS: {
    monetary_units: 2,
    name: 'Somali Shilling',
  },
  SSP: {
    monetary_units: 2,
    name: 'South Sudanese Pound',
  },
  LKR: {
    monetary_units: 2,
    name: 'Sri Lanka Rupee',
  },
  SDG: {
    monetary_units: 2,
    name: 'Sudanese Pound',
  },
  SRD: {
    monetary_units: 2,
    name: 'Surinam Dollar',
  },
  SZL: {
    monetary_units: 2,
    name: 'Lilangeni',
  },
  SEK: {
    monetary_units: 2,
    name: 'Swedish Krona',
  },
  CHE: {
    monetary_units: 2,
    name: 'WIR Euro',
  },
  CHW: {
    monetary_units: 2,
    name: 'WIR Franc',
  },
  SYP: {
    monetary_units: 2,
    name: 'Syrian Pound',
  },
  TWD: {
    monetary_units: 2,
    name: 'New Taiwan Dollar',
  },
  TJS: {
    monetary_units: 2,
    name: 'Somoni',
  },
  TZS: {
    monetary_units: 2,
    name: 'Tanzanian Shilling',
  },
  THB: {
    monetary_units: 2,
    name: 'Baht',
  },
  TOP: {
    monetary_units: 2,
    name: 'Pa\u2019anga',
  },
  TTD: {
    monetary_units: 2,
    name: 'Trinidad and Tobago Dollar',
  },
  TND: {
    monetary_units: 3,
    name: 'Tunisian Dinar',
  },
  TRY: {
    monetary_units: 2,
    name: 'Turkish Lira',
  },
  TMT: {
    monetary_units: 2,
    name: 'Turkmenistan New Manat',
  },
  UGX: {
    monetary_units: 0,
    name: 'Uganda Shilling',
  },
  UAH: {
    monetary_units: 2,
    name: 'Hryvnia',
  },
  AED: {
    monetary_units: 2,
    name: 'UAE Dirham',
  },
  USN: {
    monetary_units: 2,
    name: 'US Dollar (Next day)',
  },
  UYU: {
    monetary_units: 2,
    name: 'Peso Uruguayo',
  },
  UYI: {
    monetary_units: 0,
    name: 'Uruguay Peso en Unidades Indexadas (URUIURUI)',
  },
  UZS: {
    monetary_units: 2,
    name: 'Uzbekistan Sum',
  },
  VUV: {
    monetary_units: 0,
    name: 'Vatu',
  },
  VEF: {
    monetary_units: 2,
    name: 'Bol\u00edvar',
  },
  VND: {
    monetary_units: 0,
    name: 'Dong',
  },
  YER: {
    monetary_units: 2,
    name: 'Yemeni Rial',
  },
  ZMW: {
    monetary_units: 2,
    name: 'Zambian Kwacha',
  },
  ZWL: {
    monetary_units: 2,
    name: 'Zimbabwe Dollar',
  },
  penceToPounds(amount) {
    return amount ? amount * 100 : 0;
  },
};

export default CurrencyUtils;
